import React, { type FC } from "react";
import { Body } from "@edreamsodigeo/prisma-design-system";

import withConfidentialData from "../../../maskingData/withConfidentialData";
import type { SuccessBodyEmailType } from "./contract";

const Component: FC<SuccessBodyEmailType> = ({ email, className }) => {
  return (
    <Body type="base" weight="medium" color="neutral.80" className={className}>
      {email}
    </Body>
  );
};
const SuccessBodyEmail = withConfidentialData(Component);
export default SuccessBodyEmail;
